import {
    graphql
} from 'react-relay'


const query = graphql`
    query getAllCurrencyQuery ($pagination: PaginationInput, $sorts: [OrderInput!], $where: JSON) {
        getAllCurrency (pagination: $pagination, sorts: $sorts, where: $where) {
            count,
            items {
                id
                name
                code
                createdAt
                updatedAt
            }
      }
    }
  `

  export default query;